import React from "react";

const ButtonQuestion = ({ question, value = "", onChange }) => {
    return (
        <div className="question button-question py-4 py-lg-5">
            <div className="chat-message">
                <h4 className="m-0" dangerouslySetInnerHTML={{ __html: question.label }}/>
                {question.sublabel && (<p className="mb-0 mt-1" dangerouslySetInnerHTML={{ __html: question.sublabel }}/>)}
            </div>
            <div className="row pt-4">
                {question.answers.map((option) => {
                    const isSelected = value === option.label;

                    return (
                        <div className="col-auto">
                            <button
                                key={option.ans_id}
                                className={` chat-answer-option ${isSelected ? "selected" : ""}`}
                                onClick={() => onChange(option.label)}
                            >
                                {option.label}
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ButtonQuestion;
